import React, { useCallback, useReducer } from 'react';
import { CreateStudioActionTypes } from '../createStudioModalActions';
import { createStudioReducer } from './createStudioModalReducer';
import {
	createStudioInitialState,
	CreateStudioContext,
	TTypeOfCreateStudioModalWindow,
} from './createStudioModalContext';
import { ICreateGameDeveloper } from 'types';

const CreateStudioState = ({ children }: JSX.ElementChildrenAttribute) => {
	const [state, dispatch] = useReducer(createStudioReducer, createStudioInitialState);

	const changeName = useCallback((value: string) => {
		dispatch({
			type: CreateStudioActionTypes.CHANGE_NAME,
			payload: {
				name: value,
			},
		});
	}, []);

	const setDataForSubmit = useCallback((value: ICreateGameDeveloper | null) => {
		dispatch({
			type: CreateStudioActionTypes.SET_DATA_FOR_SUBMIT,
			payload: {
				dataForSubmit: value,
			},
		});
	}, []);

	const changeTypeOfModalWindow = useCallback((value: TTypeOfCreateStudioModalWindow) => {
		dispatch({
			type: CreateStudioActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW,
			payload: {
				typeOfModalWindow: value,
			},
		});
	}, []);

	const resetFields = useCallback(() => dispatch({ type: CreateStudioActionTypes.RESET_FIELDS }), []);

	return (
		<CreateStudioContext.Provider
			value={{
				changeName,
				setDataForSubmit,
				changeTypeOfModalWindow,
				resetFields,
				name: state.name,
				dataForSubmit: state.dataForSubmit,
				typeOfModalWindow: state.typeOfModalWindow,
			}}>
			{children}
		</CreateStudioContext.Provider>
	);
};

export default React.memo(CreateStudioState);
